import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../utils/service-http';
import { getAppLocale } from '../../utils/app-locale';
import { api_base_url } from '../../constants';
import { appConfiguration } from '../../utils/app-starter';

const DEFAULT_STATE_RACKS = { categories: [], isLoading: false, error: null };


const getHMCCategoriesStarted = createAction('GET_HMC_CATEGORIES_STARTED');
const getHMCCategoriesSuccess = createAction('GET_HMC_CATEGORIES_SUCCESS');
const getHMCCategoriesFailed = createAction('GET_HMC_CATEGORIES_FAILED');


export const hmcCategoriesReducer = createReducer(function (on, off) {
  on(getHMCCategoriesStarted, (state, payload) => {
    return {
      categories: [],
      isLoading: true,
      error: null,
    };
  });
  on(getHMCCategoriesSuccess, (state, payload) => {
    return {
      categories: payload,
      isLoading: false,
      error: null,
    };
  });
  on(getHMCCategoriesFailed, (state, payload) => {
    return {
      categories: [],
      isLoading: false,
      error: null,
    };
  });
}, DEFAULT_STATE_RACKS);


export const getHMCCategories = (criteria) => {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';


  return async dispatch => {
    dispatch(getHMCCategoriesStarted());
    return API_INSTANCE.post(`${api_base_url}/get-hmc-categories?locale=${getAppLocale()}${mainOverrideString}`,
      {
        criteria: { ...criteria, },
      })
      .then((success) => {
        let categories = success.data.payload.categories;
        if (!appConfiguration.enabledTechnologies?.pac_complex) {
          categories = categories.filter(cat => cat.variable !== 'Control Expert');
        }

        dispatch(getHMCCategoriesSuccess(categories));
        return categories;
      }).catch((error) => {
        dispatch(getHMCCategoriesFailed(error.message));
        throw error;
      });
  }
}
